export default __webpack_public_path__ + "images/1518bb873ab6cfc81f325cbe8c15672e-heritage.jpg";